import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CompleteDigitalWalletTokenProvisioningRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { CompleteDigitalWalletTokenProvisioningResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const completeDigitalWalletTokenProvisioning = (
  request: CompleteDigitalWalletTokenProvisioningRequest,
  options?: CashRequestOptions
) =>
  post<CompleteDigitalWalletTokenProvisioningRequest, CompleteDigitalWalletTokenProvisioningResponse>(
    '/2.0/cash/complete-digital-wallet-token-provisioning',
    request,
    { ...options, rejectOnError: true }
  )
